import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";

// The company's ONE Primary Facebook Group (Companies -> General). Every ad's official auction post goes here.
export function PrimaryGroupCard({ url }) {
  return (
    <section data-testid="lab-primary-group" className="bg-white border border-stone-200 rounded-xl p-4 space-y-2">
      <h2 className="font-semibold">Primary Facebook Group</h2>
      {url ? (
        <a data-testid="lab-primary-group-url" href={url} target="_blank" rel="noreferrer" className="text-sm text-[#1877F2] hover:underline break-all inline-flex items-center gap-1">{url}<ExternalLink className="h-3 w-3" /></a>
      ) : <p data-testid="lab-primary-group-missing" className="text-sm text-red-700">Not set — nothing can be posted yet.</p>}
      <p className="text-xs text-stone-600">
        Every horse ad is posted once to this group; that original post is the official auction post where comments, bids and engagement are tracked.
        While testing in preview, set it to your private test group in <Link to="/platform/companies" className="underline">Companies → General</Link>. Preview settings are separate from production.
      </p>
    </section>
  );
}
